import React from 'react'
// import "../../styles/UserDashboard/EnergyEfficiencyOverview.scss"
// import SideBar from "../../components/AdminDashboard/SideBar";
import SideBar from "../../components/UserDashboard/SideBar";
import EfficiencyHeader from '../../components/Efficiency/EfficiencyHeader';
import EfficiencyUpdate from '../../components/Efficiency/EfficiencyUpdate';
function EnergyEfficiencyOverview() {
  return (
    <div className="relative flex ">
        {/* side bar */}
        <div >
            <SideBar  />
             </div>
             
        <div >
          <div className='mt-40 ml-[1000px]'>
          <EfficiencyHeader  />

          </div >
          <div className='ml-[20px]'>
          <EfficiencyUpdate />

          </div>


        </div>
        

    </div>
  )
}

export default EnergyEfficiencyOverview
